module.exports = __webpack_public_path__ + "img/mystery.8aa63da0.svg";